import RsvpsDuplicates from '../../../store/rsvps/duplicates';

angular
    .module('festzelt-os.guestlists')
    .factory('RsvpDuplicates', [
        '$injector',
        'Rsvp',
        ($injector, Rsvp) => {
            return {
                create(name) {
                    return new RsvpsDuplicates(name, Rsvp, {
                        injector: $injector
                    });
                }
            }
        }
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/store/rsvp-duplicates.js